<script lang="ts">
  import { t } from '$lib/i18n/index.svelte';
  import { defang } from '$lib/protocol/link-guard';
  import type { LocationElement } from '$lib/protocol/types';

  let { element }: { element: LocationElement } = $props();

  let copied = $state(false);

  const coordinates = $derived(
    element.latitude !== undefined && element.longitude !== undefined
      ? `${element.latitude.toFixed(6)}, ${element.longitude.toFixed(6)}`
      : undefined,
  );

  // A text card and a copy action — no map links are ever rendered (the link ban
  // applies to the client's own output too).
  async function copy(): Promise<void> {
    if (coordinates === undefined) {
      return;
    }
    try {
      await navigator.clipboard.writeText(coordinates);
      copied = true;
      setTimeout(() => (copied = false), 2000);
    } catch {
      // Clipboard refused — nothing to do.
    }
  }
</script>

<div class="location">
  <span aria-hidden="true">📍</span>
  <div class="body">
    {#if element.name !== undefined}<strong>{defang(element.name)}</strong>{/if}
    {#if element.address !== undefined}<p>{defang(element.address)}</p>{/if}
    {#if coordinates !== undefined}
      <p class="coords">{coordinates}</p>
      <button onclick={() => void copy()}>{copied ? t('el.location.copied') : t('el.location.copy')}</button>
    {/if}
  </div>
</div>

<style>
  .location {
    display: flex;
    gap: 8px;
    min-width: 200px;
  }
  .body p {
    margin: 2px 0;
    font-size: 14px;
  }
  .coords {
    color: var(--ink-soft);
    font-family: ui-monospace, monospace;
    font-size: 13px;
  }
  button {
    border: 0;
    background: transparent;
    color: var(--brand);
    font-weight: 600;
    cursor: pointer;
    padding: 0;
    font-size: 14px;
  }
</style>
